import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/design/design/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <blockquote>
      <p parentName="blockquote">{`“Whether you call it taste, culture, or zen, there are underlying assumptions that members of an organization rely on to resolve ambiguity in pursuit of the organization’s mission.”`}<br parentName="p"></br>{`
`}{`– `}<a parentName="p" {...{
          "href": "https://ben.balter.com/2015/08/12/the-zen-of-github/"
        }}>{`Ben Balter`}</a></p>
    </blockquote>
    <p>{`The `}<a parentName="p" {...{
        "href": "https://api.github.com/zen"
      }}>{`GitHub API`}</a>{` consolidates the Zen of GitHub in its own codebase, in 14 aphorisms:`}</p>
    <ul>
      <li parentName="ul">{`Responsive is better than fast`}</li>
      <li parentName="ul">{`It’s not fully shipped until it’s fast`}</li>
      <li parentName="ul">{`Anything added dilutes everything else`}</li>
      <li parentName="ul">{`Practicality beats purity`}</li>
      <li parentName="ul">{`Approachable is better than simple`}</li>
      <li parentName="ul">{`Mind your words, they are important`}</li>
      <li parentName="ul">{`Speak like a human`}</li>
      <li parentName="ul">{`Half measures are as bad as nothing at all`}</li>
      <li parentName="ul">{`Encourage flow`}</li>
      <li parentName="ul">{`Non-blocking is better than blocking`}</li>
      <li parentName="ul">{`Favor focus over features`}</li>
      <li parentName="ul">{`Avoid administrative distraction`}</li>
      <li parentName="ul">{`Design for failure`}</li>
      <li parentName="ul">{`Keep it logically awesome`}</li>
    </ul>
    <p>{`We recommend you to read about the story behind the Zen of Github in these posts:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://warpspire.com/posts/taste"
        }}>{`Taste and The Zen of GitHub`}</a>{`, by `}<a parentName="li" {...{
          "href": "https://github.com/kneath"
        }}>{`@kneath`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://ben.balter.com/2015/08/12/the-zen-of-github/"
        }}>{`The Zen of GitHub`}</a>{`, by `}<a parentName="li" {...{
          "href": "https://github.com/benbalter"
        }}>{`@benbalter`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      